import { render, staticRenderFns } from "./UsageCard.vue?vue&type=template&id=20fc33e6&"
import script from "./UsageCard.vue?vue&type=script&lang=js&"
export * from "./UsageCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports